

/**
 * Parses a Keep a Changelog formatted markdown string into structured release objects.
 *
 * Returns an array of:
 * {
 *   version: string,
 *   date: string,
 *   sections: [{ heading: string, items: string[] }]
 * }
 */
export function parseChangelog(markdown) {
  const releases = []
  let current = null
  let currentSection = null

  const lines = markdown.split(/\r?\n/)

  for (const line of lines) {
    // Match version heading: ## [3.2.3] - 2025-11-21
    const versionMatch = line.match(/^## \[(.+?)\]\s*-\s*(.+)/)
    if (versionMatch) {
      current = {
        version: versionMatch[1],
        date: versionMatch[2].trim(),
        sections: []
      }
      releases.push(current)
      currentSection = null
      continue
    }

    // Match section heading: ### Added, ### Changed, ### Fixed, etc.
    const sectionMatch = line.match(/^### (.+)/)
    if (sectionMatch && current) {
      currentSection = {
        heading: sectionMatch[1].trim(),
        items: []
      }
      current.sections.push(currentSection)
      continue
    }

    // Match list item: - Description text here
    const itemMatch = line.match(/^- (.+)/)
    if (itemMatch && currentSection) {
      currentSection.items.push(itemMatch[1].trim())
    }
  }

  return releases
}

function cleanVersion(version)
{
    return version.replace(/^v(\d+\.\d+\.\d+.*)$/, '$1')
}

/**
 * Hardcoded application version — update this with each release.
 * Used to append to non-release tags (dev, staging_latest) for display.
 */
const APP_VERSION = '3.4.0'

/**
 * This is used to display in the Navbar, and to determine which patch should automatically be opened.
 * @type {string}
 */
function resolveVersion() {
  const raw = import.meta.env.VITE_VERSION !== undefined ? cleanVersion(import.meta.env.VITE_VERSION) : 'N/A'

  // For dev or staging_latest tags, append the hardcoded version
  if (raw === 'dev' || raw === 'staging_latest') {
    return `${raw}-${APP_VERSION}`
  }

  return raw
}

export const currentVersion = resolveVersion()

/**
 * True when the current build is a semver release (e.g. 3.3.0).
 * False for named builds like dev-3.4.0, staging_latest-3.4.0, N/A, etc.
 */
export const isReleaseBuild = /^\d+\.\d+\.\d+$/.test(currentVersion)

export const changelogURL = "https://cruzcontrolapp.s3.us-east-2.amazonaws.com/CHANGELOG.md"
